import { getSocialNetworkUid, SocialNetwork, SocialNetworkSchema } from '../models/SocialNetwork'
import { getFinder, getInserter } from 'src/util/src/zod'
import { AnchorFm, DiscordCom, FacebookCom, GitHubCom, InstagramCom, LinkedInCom, MediumCom, PinterestCom, RedditCom, TelegramOrg, TwitterCom, YouTubeCom } from './allDomains'

export const allSocialNetworks: SocialNetwork[] = []

export const addSocialNetwork = getInserter('SocialNetwork', SocialNetworkSchema, getSocialNetworkUid, allSocialNetworks)

export const findSocialNetwork = getFinder(getSocialNetworkUid, allSocialNetworks)

export const Facebook = addSocialNetwork({
  name: 'Facebook',
  domain: FacebookCom,
})

export const Twitter = addSocialNetwork({
  name: 'Twitter',
  domain: TwitterCom,
})

export const Telegram = addSocialNetwork({
  name: 'Telegram',
  domain: TelegramOrg,
})

export const Discord = addSocialNetwork({
  name: 'Discord',
  domain: DiscordCom,
})

export const Instagram = addSocialNetwork({
  name: 'Instagram',
  domain: InstagramCom,
})

export const Pinterest = addSocialNetwork({
  name: 'Pinterest',
  domain: PinterestCom,
})

export const YouTube = addSocialNetwork({
  name: 'YouTube',
  domain: YouTubeCom,
})

export const Reddit = addSocialNetwork({
  name: 'Reddit',
  domain: RedditCom,
})

export const Medium = addSocialNetwork({
  name: 'Medium',
  domain: MediumCom,
})

export const GitHub = addSocialNetwork({
  name: 'GitHub',
  domain: GitHubCom,
})

export const LinkedIn = addSocialNetwork({
  name: 'LinkedIn',
  domain: LinkedInCom,
})

export const Anchor = addSocialNetwork({
  name: 'Anchor',
  domain: AnchorFm,
})
